<template>
  <div id="app">
    <!--notification -->
    <notifications group="foo" position='top left' />

    <!--navbar -->
    <transition name="slideDown">
      <nav-bar v-show="navBarShow" @wannaSet="settingModalShow = true" />
    </transition>

    <!--burger (Trigger navbar show) -->
    <div class="burger" @click="navBarShow = !navBarShow">
      <span></span>
      <span></span>
      <span></span>
    </div>

    <!--modal contain setting / QA / about -->
    <modal-box/>

    <!--main app-->
    <main>
      <chat-box/>
    </main>
  </div>
</template>

<script>
import navBar from '@/components/navBar';
import chatBox from '@/components/chat/chatBox';
import modalBox from '@/components/modal/modalBox';
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'app',
  components: { navBar, chatBox, modalBox },
  data() {
    return {
      navBarShow: false
    };
  },
  computed: {
    ...mapState('modal', ['QAmodal', 'aboutModal', 'settingModal'])
  },
  methods: {
    ...mapMutations('modal', ['modalOpen']),
    ...mapMutations('information', ['settingSex', 'settingCity'])
  },
  mounted() {
    let info = this.$ls.get('information');
    if (info === null) {
      //this.settingModalShow = true;
      this.modalOpen('settingModal');
    } else {
      this.settingSex(info.sex);
      this.settingCity(info.city);
    }
  }
};
</script>

<style lang="scss">
//Border Box
* {
  box-sizing: border-box;
}

//Transition
.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s ease-in;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.fade-enter-to,
.fade-leave {
  opacity: 1;
}

.slideDown-enter-active,
.slideDown-leave-active {
  //  transition: margin-left 1s ease-in-out;
  //  transition: max-width 0.5s ease-in-out;
  transition: all 0.5s ease;
  transform: translate3d(0px, -60px, 0px);
}
.slideDown-enter,
.slideDown-leave-to {
  // margin-left: -260px;
  transform: translate3d(0px, -60px, 0px);
  opacity: 0;
}
.slideDown-enter-to,
.slideDown-leave {
  //margin-left: 0px;
  transform: translate3d(0px, 0px, 0px);
  opacity: 1;
}

.slide-enter-active,
.slide-leave-active {
  //  transition: margin-left 1s ease-in-out;
  //  transition: max-width 0.5s ease-in-out;
  transition: all 0.4s ease-in-out;
  transform: translate3d(-240px, 0px, 0px);
}
.slide-enter,
.slide-leave-to {
  // margin-left: -260px;
  max-width: 0px;
  transform: translate3d(-240px, 0px, 0px);
}
.slide-enter-to,
.slide-leave {
  //margin-left: 0px;
  max-width: 240px;
  transform: translate3d(0px, 0px, 0px);
}
//End of Transition

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  position: fixed;
  height: 100%;
  width: 100%;
  background: linear-gradient(to right, rgb(249, 205, 194), rgb(213, 240, 250));
}
button {
  outline: none;
  cursor: pointer;
}
.burger {
  z-index: 2;
  cursor: pointer;
  user-select: none;
  position: absolute;
  top: 15px;
  right: 20px;
  text-align: left;
  * {
    width: 25px;
    border-bottom: 2px solid rgba(2, 2, 2, 0.4);
    text-shadow: #2c3e50;
    height: 7px;
    display: block;
    font-weight: bold;
  }
}
main {
  height: 100%;
  position: relative;
  /*
  & > .hotkey {
    position: absolute;
    padding: 5px;
    right: 20px;
    top: 20px;
    font-size: 25px;
    color: rgb(150, 150, 150);
    cursor: pointer;
    border: 1px rgb(100, 100, 100) solid;
    border-radius: 10%;
    background-color: rgb(240, 240, 240);
  }
  */
}

//For message wrapper (QA modal / About modal)
.message-wrapper {
  $me_bg: rgb(170, 250, 140);
  $you_bg: white;
  $boy_bg: rgb(82, 170, 211);
  //$girl_bg: rgb(235, 139, 139);
  $girl_bg: rgb(233, 138, 141);
  display: flex;
  flex-wrap: wrap;
  padding: 10px 20px;
  & > .message-img {
    max-width: 80%;
  }
  //specific
  & > .message {
    max-width: 80%;
    color: #4b4f56;
    border-radius: 1em;
    padding: 0.5em 0.8em;
    position: relative;
    word-wrap: break-word;
    white-space: pre-wrap; /* Since CSS 2.1 */
    line-height: 1.3em;
    font-size: 18px;
  }
  & > .you {
    color: rgb(240, 240, 240);
    background-color: $you_bg;
  }
  & > .me {
    background-color: $me_bg;
  }
  & > .you:before {
    content: '';
    position: absolute;
    top: 0;
    left: -0.5em;
    width: 0.5em;
    height: 1em;
    border-right: 0.5em solid $you_bg;
    border-top-right-radius: 1em 0.5em;
  }
  & > .me:after {
    content: '';
    position: absolute;
    top: 0;
    right: -0.5em;
    width: 0.5em;
    height: 1em;
    border-left: 0.5em solid $me_bg;
    border-top-left-radius: 1em 0.5em;
  }
  & > .boy {
    background-color: $boy_bg;
  }
  & > .boy:before {
    border-right: 0.5em solid $boy_bg;
  }
  & > .girl {
    background-color: $girl_bg;
  }
  & > .girl:before {
    border-right: 0.5em solid $girl_bg;
  }
  & > .success:after {
    content: '✓';
  }
  & > .system {
    max-width: 100%;
    font-size: 16px;
    font-weight: bold;
    opacity: 0.6;
  }
}

.vue-notification {
  //workaround - because webpack order
  margin:5px !important;
  border-radius: 5px !important;
  opacity: 0.9 !important;
  padding: 15px !important;
  font-size: 18px !important;
}
</style>
